<script>
    /**
     * Declara UMA coluna do Excel. Não renderiza nada: apenas se registra no <ExcelExport>.
     *
     * Props:
     *  - title:    cabeçalho da coluna no Excel
     *  - value:    caminho do campo no objeto retornado (aceita "user.name")
     *  - callback: (opcional) formata o valor antes de gravar. Recebe o valor do campo.
     *
     * Ex.: <ExcelHeaderColumn title="Criado em" value="created_at" :callback="formatDate" />
     *
     * As colunas são lidas pelo <ExcelExport> só no momento do "Preparar relatório",
     * então callbacks inline (ex.: :callback="v => formatDate(v)") são seguros.
     */
    export default {
        name: 'ExcelHeaderColumn',
        inject: {
            excelExport: { default: null },
        },
        props: {
            title: { type: String, required: true },
            value: { type: String, required: true },
            callback: { type: Function, default: null },
        },
        created() {
            if (this.excelExport) this.excelExport.register(this);
        },
        beforeDestroy() {
            if (this.excelExport) this.excelExport.unregister(this);
        },
        render() {
            return null;
        },
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/_micro/Excel/ExcelHeaderColumn.vue